import { render, staticRenderFns } from "./W9Form.vue?vue&type=template&id=311ac83c&scoped=true&"
import script from "./W9Form.vue?vue&type=script&lang=js&"
export * from "./W9Form.vue?vue&type=script&lang=js&"
import style0 from "./W9Form.vue?vue&type=style&index=0&id=311ac83c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ac83c",
  null
  
)

export default component.exports